<template>
  <div>
    <el-form ref="pwdForm" :model="pwdForm" status-icon label-position="top" :rules="pwdRules" class="formContainer">
      <el-form-item :label="$t('system.login_email') + ':'" prop="email">
        <el-input v-model="emailDesensitization" autocomplete="off" disabled clearable />
      </el-form-item>
      <el-form-item :label="$t('system.password')" prop="pass" required style="margin-bottom:40px">
        <el-input v-model="pwdForm.pass" placeholder="Enter your new password" type="password" autocomplete="off" show-password clearable />
      </el-form-item>
      <el-form-item :label="$t('system.confirm_password')" prop="checkPass" required>
        <el-input v-model="pwdForm.checkPass" placeholder="Confirm your new password" type="password" autocomplete="off" show-password clearable />
      </el-form-item>
      <el-form-item :label="$t('system.mfa_verify_code')" prop="mfa_code" required>
        <el-input v-model="pwdForm.mfa_code" maxlength="6" placeholder="Enter your MFA verification code" autocomplete="off" clearable />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { modifyUserPwd } from '@/api/system/system'
import { cryptoJSAesEncrypt, cryptoJSAesDecrypt } from '@/utils/encrypt'

export default {
  name: 'ValiEmailForm',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 8 || value.length > 15) {
        return callback(new Error('password must between 8 ~ 15 character'))
      }
      const regex = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@%*&_])[A-Za-z\\d@%*&_]{8,15}$')
      if (!regex.test(value)) {
        return callback(new Error('Passwords must be between 8 and 15 characters. Must contain and only contain the following: uppercase and lowercase letters, alphabets, and special characters (limited to @%*&_).'))
      }
      return callback()
    }
    const validatePass2 = (rule, value, callback) => {
      const pass2Length = value.trim().length
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (pass2Length < 8 || pass2Length > 15) {
        callback(new Error('Your password must be 8 ~ 15 characters long'))
      } else if (value !== this.pwdForm.pass) {
        callback(new Error('The two passwords are inconsistent!'))
      } else {
        callback()
      }
    }
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length < 6 || value.length > 6) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    return {
      pwdForm: {
        pass: '',
        checkPass: '',
        mfa_code: ''
      },
      pwdRules: {
        pass: [
          { validator: validatePass, trigger: ['blur', 'change'] }
        ],
        checkPass: [
          { validator: validatePass2, trigger: ['blur', 'change'] }
        ],
        mfa_code: [
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    emailAddress() {
      const { email } = this.$store.getters
      return cryptoJSAesDecrypt(email)
    },
    emailDesensitization() {
      const { email } = this.$store.getters
      // return strAesDecryptAndEmailAsterisk(legalEmail)
      return email
    }
  },
  mounted() {
  },
  methods: {
    initData() {
      this.pwdForm = {
        pass: '',
        checkPass: '',
        mfa_code: ''
      }
      this.$refs['pwdForm'].clearValidate()
    },
    submitPwdForm() {
      // 请求接口
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          const { pass, mfa_code } = this.pwdForm
          const params = { password: cryptoJSAesEncrypt(pass), mfa_code: mfa_code }
          modifyUserPwd(params).then(res => {
            if (res.code === 10000) {
              this.$emit('changeStepStatus', 2)
              this.$emit('changeModalStatus', false)
              this.$message({
                showClose: true,
                message: 'Success',
                type: 'success'
              })
              const { naire_status, account_type } = this.$store.state.user.userInfo
              // 如果没有填调查问卷，跳出问卷页
              if (naire_status === 2 && account_type === 1) {
                this.$store.commit('user/SET_MODTIFY_PWD_STATUS', false)
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.$router.push('/questionnaire')
                  }, 100)
                })
              }
              // 更新user信息
              this.$store.dispatch('user/getInfo')
              // this.logout()
            }
          }).catch(err => {
            console.error(err)
          })
        } else {
          console.log('error submit!!')
          this.$message({ message: 'Please submit after completing verification', type: 'warning' })
          return false
        }
      })
    }
    // async logout() {
    //   await this.$store.dispatch('user/logout')
    //   this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    // },
  }
}
</script>

<style scoped>

.formContainer{
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.send-email{
  margin-left: 15px;
}
</style>
